import { useHomepageDataQuery } from './useHomepageDataQuery';

/**
 * Shared homepage data hook that fetches all data needed for homepage widgets
 * This ensures only ONE API call is made for all widgets instead of separate calls
 */
export const useSharedHomepageData = () => {
  return useHomepageDataQuery({
    blog_count: 3,
    event_count: 3,
    gallery_count: 1,
    featured_only: false // Get all data, widgets can filter as needed
  });
};
